import { render } from "./AboutContent.vue?vue&type=template&id=d91d4dee&scoped=true"
import script from "./AboutContent.vue?vue&type=script&lang=js"
export * from "./AboutContent.vue?vue&type=script&lang=js"

import "./AboutContent.vue?vue&type=style&index=0&id=d91d4dee&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d91d4dee"]])

export default __exports__